import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import RowActions, { type RowAction } from '../../../../components/RowActions';
import type { SettingsOptionRow } from '../../types';
import { OPTION_ROW_LABELS as LABELS } from '../../../../utils/labels';

interface OptionRowProps {
  option: SettingsOptionRow;
  showDivider: boolean;
  onEdit?: () => void;
  onArchive?: () => void;
  onUnarchive?: () => void;
  onDelete?: () => void;
}

export default function OptionRow({
  option,
  showDivider,
  onEdit,
  onArchive,
  onUnarchive,
  onDelete,
}: OptionRowProps) {
  const actions: RowAction[] = option.archived
    ? onUnarchive
      ? [{ label: LABELS.unarchive, icon: <UnarchiveOutlinedIcon fontSize="small" />, onClick: onUnarchive, color: 'success', testId: 'unarchive-button' }]
      : []
    : [
        ...(onEdit ? [{ label: LABELS.edit, icon: <EditIcon fontSize="small" />, onClick: onEdit, color: 'primary' as const, testId: 'edit-button' }] : []),
        ...(option.has_machines
          ? onArchive
            ? [{ label: LABELS.archive, icon: <ArchiveOutlinedIcon fontSize="small" />, onClick: onArchive, color: 'warning' as const, testId: 'archive-button' }]
            : []
          : onDelete
            ? [{ label: LABELS.delete, icon: <DeleteOutlineIcon fontSize="small" />, onClick: onDelete, color: 'error' as const, testId: 'delete-button' }]
            : []),
      ];

  return (
    <div>
      {showDivider && <hr className="border-border-subtle" />}
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="flex-1 min-w-0">
          <p className={`font-medium mb-0 mt-0 truncate ${option.archived ? 'text-text-secondary' : ''}`}>
            {option.name}
          </p>
        </div>
        <div className="flex items-center gap-1 shrink-0">
          <RowActions actions={actions} />
        </div>
      </div>
    </div>
  );
}
